import { apiClient } from "@/api/client";
import type { DriverRanking } from "@/types/domain";

/**
 * GET /admin/rankings?limit — delegates to apps/rating-service's driver
 * leaderboard (drivers/ranking). Returns a plain array (not paginated) — the
 * backend is the sole source of rank/score, never recomputed client-side.
 */
export const rankingsApi = {
  list: (limit = 50) =>
    apiClient
      .get<DriverRanking[]>("/admin/rankings", { params: { limit } })
      .then((r) => r.data),
};
